var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.712,
    height: 87.543,
    viewBox: "0 0 30.712 87.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-7586.189-5281.991a6.846,6.846,0,0,1-6.839-6.838,6.794,6.794,0,0,1,2-4.835,6.792,6.792,0,0,1,4.836-2,6.847,6.847,0,0,1,6.838,6.838,6.8,6.8,0,0,1-2,4.835A6.8,6.8,0,0,1-7586.189-5281.991Zm0-9.97a3.11,3.11,0,0,0-2.213.917,3.107,3.107,0,0,0-.918,2.215,3.134,3.134,0,0,0,3.131,3.13,3.115,3.115,0,0,0,2.216-.916,3.121,3.121,0,0,0,.914-2.214A3.135,3.135,0,0,0-7586.189-5291.96Z",
    transform: "translate(7601.546 5295.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-7614.72-5159.329a1.854,1.854,0,0,1-1.853-1.853v-26.554a11.663,11.663,0,0,0-11.649-11.65,11.662,11.662,0,0,0-11.649,11.65v26.554a1.853,1.853,0,0,1-1.853,1.853,1.853,1.853,0,0,1-1.855-1.853v-26.554a15.375,15.375,0,0,1,15.357-15.357,15.373,15.373,0,0,1,15.354,15.357v26.554A1.853,1.853,0,0,1-7614.72-5159.329Z",
    transform: "translate(7643.579 5218.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-7582.108-5043.686a5.978,5.978,0,0,1-4.252-1.762,5.975,5.975,0,0,1-1.76-4.249v-46.354a1.854,1.854,0,0,1,1.855-1.854,1.853,1.853,0,0,1,1.854,1.854v46.354a2.294,2.294,0,0,0,.675,1.629,2.288,2.288,0,0,0,1.628.673,2.306,2.306,0,0,0,2.3-2.3v-46.354a1.853,1.853,0,0,1,1.854-1.854,1.855,1.855,0,0,1,1.854,1.854l0,46.354A6.018,6.018,0,0,1-7582.108-5043.686Z",
    transform: "translate(7597.465 5131.229)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleToilet);
export default __webpack_public_path__ + "static/media/MaleToilet.d5317d74.svg";
export { ForwardRef as ReactComponent };